import { render } from "./Styleguide-Section.vue?vue&type=template&id=f7999404"
import script from "./Styleguide-Section.vue?vue&type=script&lang=js"
export * from "./Styleguide-Section.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__